import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Input from '../input';
import Select from '../select';
import SocialForm from '../social-form';
import RoundCheck from '../round-check';
import Checkbox from '../checkbox';
import ChildrenBlock from '../children-block';

class CardForm extends Component {
  static propTypes = {
    data: PropTypes.shape({
      user_id: PropTypes.number,
      phone: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string,
      email: PropTypes.string,
      birthday: PropTypes.string,
      gender: PropTypes.number,
      city: PropTypes.string,
      district: PropTypes.string,
      childs: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          birthday: PropTypes.string,
          gender: PropTypes.number,
        }),
      ),
    }),
    error: PropTypes.string,
    loading: PropTypes.bool,
    confirm: PropTypes.func,
    short: PropTypes.bool,
    step: PropTypes.number,
  };

  static defaultProps = {
    error: null,
    short: false,
    step: 0,
    loading: false,
  };

  confirm = e => {
    e.preventDefault();
    this.props.confirm(this.form);
  };

  render() {
    const { confirm, data, error, loading, short, step, birthday } = this.props;

    let style = short || step == 1 ? { display: 'none' } : null;
    let btnClasses = ['btn'];

    if (loading) btnClasses.push('btn--loading');

    const dataBlock = (
      <div className="row">
        {data.last_name === null || (data && data.last_name.trim() === '') ? (
          <div className="inp-group__case">
            <Input
              label="Фамилия"
              name="last_name"
              placeholder="Фамилия"
              lang="rus"
              indie
              required
            />
          </div>
        ) : null}
        {data.first_name === null || (data && data.first_name.trim() === '') ? (
          <div className="inp-group__case">
            <Input
              label="Имя"
              name="first_name"
              placeholder="Имя"
              lang="rus"
              indie
              required
            />
          </div>
        ) : null}
        {data.patronymic === null || (data && data.patronymic.trim() === '') ? (
          <div className="inp-group__case">
            <Input
              label="Отчество"
              name="patronymic"
              placeholder="Отчество"
              lang="rus"
              indie
              required
            />
          </div>
        ) : null}
        {data.phone && `${data.phone}`.length == 11 ? null : (
          <div className="inp-group__case">
            <Input
              label="Номер телефона"
              name="phone"
              phone
              placeholder="Укажите номер телефона"
              value={data.phone || ''}
              indie
              required
            />
          </div>
        )}
        {data.email === null || (data && data.email.trim() === '') ? (
          <div className="inp-group__case">
            <Input
              label="E-mail"
              name="email"
              placeholder="Укажите e-mail"
              value={data.email || ''}
              onChange={this.changeData}
              indie
              required
            />
          </div>
        ) : null}
        {data.accept_rules === null || (data && data.accept_rules == 0) ? (
          <div className="inp-group__case">
            <Checkbox
              checked={data.accept_rules == 1}
              name="accept_rules"
              value={data.accept_rules}
              label={
                <p>
                  Согласие на&nbsp;обработку{' '}
                  <a href={data.pd} target="_blank" className="link">
                    персональных&nbsp;данных
                  </a>
                </p>
              }
            />
          </div>
        ) : null}
        {data.birthday === null || data.gender === null ? (
          <div className="inp-group__case">
            {data.birthday == null ? (
              <div className="wrap wrap--day">
                <Input
                  label="Дата рождения"
                  name="birthday"
                  date
                  placeholder="дд.мм.гггг"
                  indie
                  required
                />
              </div>
            ) : null}
            {data.gender == null ? (
              <div className="wrap wrap--gender">
                <div className="round-checks">
                  <RoundCheck
                    checked={data.gender == 0}
                    icon="female"
                    label="Женский"
                    name="gender"
                    value={0}
                  />
                  <RoundCheck
                    checked={data.gender == 1}
                    icon="male"
                    label="Мужской"
                    name="gender"
                    value={1}
                  />
                </div>
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    );

    const childrenBlock = (
      <div className="popup__section-block">
        <div className="popup__section-title">
          <h4 className="heading heading--1 popup__title">
            Информация о детях
          </h4>
        </div>
        <ChildrenBlock data={data.childs || []} />
      </div>
    );

    const aside = (
      <div className="popup__aside">
        <div className="card-popup__pic">
          {
            // <img className="back" />
            // <span className="mocap" />
          }
        </div>
      </div>
    );

    const close = (
      <button className="popup__close" type="button">
        <svg viewBox="0 0 18 18" width="18" height="18">
          <path d="M15.5 17.6l-6.5-6.5-6.5 6.5c-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1l6.5-6.5-6.5-6.5c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l6.5 6.5 6.5-6.5c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-6.5 6.5 6.5 6.5c.6.6.6 1.5 0 2.1-.3.3-.6.4-1 .4s-.8-.2-1.1-.4z"></path>
        </svg>
      </button>
    );

    // Маленькая форма
    if (short)
      return (
        <div className="popup" data-type="card">
          {aside}
          <form
            className="popup__content"
            ref={node => (this.form = node)}
            onSubmit={this.confirm}
          >
            <div className="popup__content-inner">
              <div className="popup__section-title">
                <h3 className="heading heading--1 popup__title">
                  Активация карты
                </h3>
              </div>
              <div className="inp-group">
                <div className="row">
                  <div
                    className="inp-group__case"
                    style={step == 1 ? { display: 'none' } : null}
                  >
                    <Input label="Номер карты" name="card" indie required />
                  </div>
                  <div
                    className="inp-group__case"
                    style={step == 1 ? { display: 'none' } : null}
                  >
                    <Select
                      label="Где выдали карту?"
                      name="department"
                      options={data.department_list}
                      indie
                    />
                  </div>
                  {step == 1 ? (
                    <div className="inp-group__case">
                      <Input
                        label="Код"
                        name="code"
                        placeholder="Введите код из СМС"
                        indie
                      />
                    </div>
                  ) : null}
                </div>
                {dataBlock}
              </div>
              {childrenBlock}
              <div className="popup__btn-wrap">
                {error ? <p>{error}</p> : null}
                <div className="wrap">
                  <button className={btnClasses.join(' ')} type="submit">
                    Активировать карту
                  </button>
                  <a
                    href="https://goo.gl/forms/zLHaz56GXXuLbxqx1"
                    target="_blank"
                    className="btn-link link--accent"
                  >
                    <span>Не получается?</span>
                  </a>
                </div>
              </div>
            </div>
          </form>
          {close}
        </div>
      );

    // Большая форма
    return (
      <div className="popup card-popup" data-type="card">
        {aside}
        <form
          className="popup__content"
          ref={node => (this.form = node)}
          onSubmit={this.confirm}
        >
          <div className="popup__section-block">
            <div className="popup__section-title">
              <h3 className="heading heading--1 popup__title">
                Активация карты
              </h3>
            </div>
            <div className="inp-group inp-group--2">
              <div className="row">
                <div className="inp-group__case" style={style}>
                  <Input label="Номер карты" name="card" indie required />
                </div>
                <div className="inp-group__case" style={style}>
                  <Select
                    label="Где выдали карту?"
                    name="department"
                    options={data.department_list}
                    indie
                  />
                </div>
                {step == 1 ? (
                  <div className="inp-group__case">
                    <Input
                      label="Код"
                      name="code"
                      placeholder="Введите код из СМС"
                      indie
                    />
                  </div>
                ) : null}
              </div>
              {dataBlock}
            </div>
          </div>
          {childrenBlock}
          <div
            className={`popup__btn-wrap${
              step == 1 ? '' : ' popup__btn-wrap--divider'
            }`}
          >
            {error ? <p>{error}</p> : null}
            <div className="wrap">
              <button className={btnClasses.join(' ')} type="submit">
                Активировать карту
              </button>
              <a
                href="https://goo.gl/forms/zLHaz56GXXuLbxqx1"
                target="_blank"
                className="btn-link link--accent"
              >
                <span>Не получается?</span>
              </a>
            </div>
          </div>
        </form>
        {close}
      </div>
    );
  }
}

export default CardForm;
